import { createEffect } from 'effector'
import type { INoraTranslationsFormat } from '../../interfaces/i18n'

//GET /v3/i18n
export const getAllFx = createEffect<void, INoraTranslationsFormat>()
